import { render, staticRenderFns } from "./GiftCardPage.vue?vue&type=template&id=63ef898e&scoped=true"
import script from "./GiftCardPage.vue?vue&type=script&lang=js"
export * from "./GiftCardPage.vue?vue&type=script&lang=js"
import style0 from "./GiftCardPage.vue?vue&type=style&index=0&id=63ef898e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef898e",
  null
  
)

export default component.exports